/*
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2022-12-20 19:39:29
 * @LastEditors: Andy
 * @LastEditTime: 2022-12-20 19:44:58
 */
export const Icons = {
  add: 'el-icon-plus',
  export: 'el-icon-download',
  upload: 'el-icon-upload2',
  delete: 'el-icon-delete',
  other: 'el-icon-connection',
  searchUp: 'el-icon-d-arrow-left',
  searchDown: 'el-icon-d-arrow-right',
  send: 'el-icon-chat-round',
  generate: 'el-icon-document'
}

export const buttonIcons = (key) => {
  return Icons[key]
}
